export const awsInstancePaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/aws/instances`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/aws/instances`,
  detail: (connectionId, region, instanceId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/instances/${encodeURIComponent(region)}/${encodeURIComponent(instanceId)}`,
  tags: (connectionId, region, instanceId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/instances/${encodeURIComponent(region)}/${encodeURIComponent(instanceId)}/tags`,
  start: (connectionId, region, instanceId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/instances/${encodeURIComponent(region)}/${encodeURIComponent(instanceId)}/start`,
  stop: (connectionId, region, instanceId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/instances/${encodeURIComponent(region)}/${encodeURIComponent(instanceId)}/stop`,
  reboot: (connectionId, region, instanceId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/instances/${encodeURIComponent(region)}/${encodeURIComponent(instanceId)}/reboot`,
  terminate: (connectionId, region, instanceId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/instances/${encodeURIComponent(region)}/${encodeURIComponent(instanceId)}/terminate`,
};
